import { render, staticRenderFns } from "./GerenciaCadastroCursos.vue?vue&type=template&id=7d82887d"
import script from "./GerenciaCadastroCursos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroCursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports